import { jsx as _jsx } from "react/jsx-runtime";
import InlineLoader from '@jetbrains/ring-ui/components/loader-inline/loader-inline';
import { BaseConstituentWidget } from '@modules/constituents/widget/base-constituent-widget';
import { ParagraphLoader } from '@common/loaders/paragraph-loader';
export function ConstituentLoadingWidget(props) {
    return (_jsx(BaseConstituentWidget, { loading: true, topRightContent: _jsx(InlineLoader, {}), controls: _jsx(ParagraphLoader, { linesNumber: 1 }), ...props }));
}
